import "./TriviaQuestion.scss";

import { Button, Flex, Text } from "@fluentui/react-northstar";
import { NominalQuestion, QuestionResponse } from "@teams/types";
import moment from "moment";
import React, { useState } from "react";

export const TriviaQuestionForm: React.FC<{
  question: NominalQuestion;
  index: number;
  response: QuestionResponse | undefined;
  onSubmit: (question: NominalQuestion, value: string) => Promise<void>;
}> = ({ question, index, response, onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState<string>();

  return (
    <Flex column gap="gap.medium">
      <Text content={`${index}) ${question.label}`} weight="bold" size="large" />

      <Flex column>
        {question.choices.map(choice => {
          const isChoice = response?.value.includes(choice.id);
          return (
            <div key={choice.id} style={{ marginBottom: ".2rem" }}>
              <Button
                content={choice.value}
                className={isChoice ? "trivia-question-results__button-selected" : ""}
                fluid
                onClick={async () => {
                  if (
                    isSubmitting ||
                    moment(question.closeDate)
                      .add(3 /* voting grace period */, "second")
                      .isSameOrBefore()
                  ) {
                    return;
                  }

                  setIsSubmitting(choice.id);
                  await onSubmit(question, choice.id);
                  setIsSubmitting(undefined);
                }}
              />
            </div>
          );
        })}
      </Flex>
    </Flex>
  );
};
